const guest = ({ next }) => {
  return next()
}

export default guest
